
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({})
export default class ConfirmDialog extends Vue {
  @Prop({ required: false }) message!: string;
  show = true;

  @Emit()
  onConfirm() {
    this.show = false;
    return;
  }

  @Emit()
  onCancel() {
    this.show = false;
    return;
  }
}
